import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import { BiArrowBack } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { api } from '../../utils/api';

const BiziDegerlendirin = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [ratings, setRatings] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [totalRatings, setTotalRatings] = useState(0);
  const [backendError, setBackendError] = useState(false);

  // Mevcut değerlendirmeleri getir
  useEffect(() => {
    fetchRatings();
  }, []);

  const fetchRatings = async () => {
    try {
      console.log('API çağrısı yapılıyor...');
      const response = await api.get('/ratings');
      console.log('API yanıtı:', response);
      const data = response.data;
      
      if (data.success) {
        setRatings(data.data.ratings);
        setAverageRating(data.data.average_rating);
        setTotalRatings(data.data.total_ratings);
        setBackendError(false);
      }
    } catch (error) {
      console.error('Değerlendirmeler yüklenirken hata:', error);
      console.error('Hata detayları:', error.response?.data);
      setBackendError(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (rating === 0) {
      setError('Lütfen bir değerlendirme seçin');
      return;
    }

    setLoading(true);
    setError('');

    try {
      console.log('Rating gönderiliyor:', { rating, comment });
      const response = await api.post('/ratings', {
        rating: rating,
        comment: comment
      });

      console.log('Rating yanıtı:', response);
      const data = response.data;

      if (data.success) {
        setSubmitted(true);
        // Yeni değerlendirmeyi ekledikten sonra listeyi güncelle
        setTimeout(() => {
          fetchRatings();
        }, 2000);
      } else {
        setError(data.message || 'Bir hata oluştu');
      }
    } catch (error) {
      console.error('Rating gönderme hatası:', error);
      console.error('Hata detayları:', error.response?.data);
      setError('Bağlantı hatası. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Backend hatası durumunda gösterilecek sayfa
  if (backendError) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900 pt-20">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-6">⚠️</div>
            <h1 className="text-3xl font-bold text-gray-800 dark:text-slate-200 mb-4">Servis Geçici Olarak Kullanılamıyor</h1>
            <p className="text-gray-600 dark:text-slate-300 text-lg mb-8">
              Değerlendirme sistemi şu anda bakımda. Lütfen daha sonra tekrar deneyin.
            </p>
            <Link 
              to="/"
              className="inline-flex items-center bg-[#EFBB4C] text-[#252836] font-semibold py-3 px-6 rounded-lg hover:bg-[#d4a63f] transition-colors"
            >
              <BiArrowBack className="mr-2" />
              Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    );
  }

     if (submitted) {
     return (
       <div className="min-h-screen bg-white dark:bg-slate-900 pt-20">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="text-center">
            <div className="text-green-500 text-6xl mb-6">✓</div>
                         <h1 className="text-3xl font-bold text-gray-800 dark:text-slate-200 mb-4">Teşekkürler!</h1>
             <p className="text-gray-600 dark:text-slate-300 text-lg mb-8">
              Değerlendirmeniz başarıyla gönderildi. Admin onayından sonra yayınlanacaktır.
            </p>
            <Link 
              to="/"
              className="inline-flex items-center bg-[#EFBB4C] text-[#252836] font-semibold py-3 px-6 rounded-lg hover:bg-[#d4a63f] transition-colors"
            >
              <BiArrowBack className="mr-2" />
              Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    );
  }

     return (
     <div className="min-h-screen bg-white dark:bg-slate-900 pt-20">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <Link 
            to="/"
            className="inline-flex items-center text-[#EFBB4C] hover:text-[#d4a63f] mb-4"
          >
            <BiArrowBack className="mr-2" />
            Geri Dön
          </Link>
                     <h1 className="text-4xl font-bold text-gray-800 dark:text-slate-200 mb-4">Bizi Değerlendirin</h1>
           <p className="text-gray-600 dark:text-slate-300 text-lg">
            Deneyiminizi bizimle paylaşın ve diğer kullanıcılara yardımcı olun
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
                     {/* Rating Form */}
           <div className="bg-slate-800 dark:bg-white border border-slate-700 dark:border-gray-200 rounded-lg p-6">
             <h2 className="text-2xl font-semibold text-slate-200 dark:text-gray-800 mb-6">Değerlendirmenizi Yapın</h2>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Star Rating */}
              <div>
                                 <label className="block text-slate-300 dark:text-gray-700 mb-3">Değerlendirmeniz</label>
                <div className="flex justify-center space-x-2">
                  {[...Array(5)].map((_, index) => {
                    const ratingValue = index + 1;
                    return (
                                             <FaStar
                         key={index}
                         className="cursor-pointer text-3xl transition-colors duration-200"
                         color={ratingValue <= (hover || rating) ? "#EFBB4C" : "#4a5568"}
                         style={{ 
                           filter: document.documentElement.classList.contains('dark') ? 'invert(1)' : 'none',
                           color: ratingValue <= (hover || rating) ? "#EFBB4C" : (document.documentElement.classList.contains('dark') ? "#ffffff" : "#4a5568")
                         }}
                         onMouseEnter={() => setHover(ratingValue)}
                         onMouseLeave={() => setHover(null)}
                         onClick={() => setRating(ratingValue)}
                       />
                    );
                  })}
                </div>
                {rating > 0 && (
                                     <p className="text-center mt-3 text-slate-300 dark:text-gray-600">
                    {rating === 1 && "Çok Kötü"}
                    {rating === 2 && "Kötü"}
                    {rating === 3 && "Orta"}
                    {rating === 4 && "İyi"}
                    {rating === 5 && "Mükemmel"}
                  </p>
                )}
              </div>

              {/* Comment */}
              <div>
                                 <label className="block text-slate-300 dark:text-gray-700 mb-3">Yorumunuz (İsteğe bağlı)</label>
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Deneyiminizi paylaşın..."
                                     className="w-full p-4 bg-slate-700 dark:bg-white border border-slate-600 dark:border-gray-300 rounded-lg text-slate-200 dark:text-gray-800 placeholder-slate-400 dark:placeholder-gray-500 focus:outline-none focus:border-[#EFBB4C] resize-none"
                  rows="4"
                  maxLength="1000"
                />
                                 <p className="text-sm text-slate-400 dark:text-gray-500 mt-1">
                  {comment.length}/1000 karakter
                </p>
              </div>

              {/* Error Message */}
              {error && (
                <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-3">
                  <p className="text-red-400">{error}</p>
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                disabled={rating === 0 || loading}
                className="w-full bg-[#EFBB4C] hover:bg-[#d4a63f] disabled:bg-slate-600 disabled:cursor-not-allowed text-[#252836] font-semibold py-4 px-6 rounded-lg transition-colors duration-200"
              >
                {loading ? 'Gönderiliyor...' : 'Değerlendirmeyi Gönder'}
              </button>
            </form>
          </div>

                     {/* Ratings Display */}
           <div className="bg-slate-800 dark:bg-white border border-slate-700 dark:border-gray-200 rounded-lg p-6">
             <h2 className="text-2xl font-semibold text-slate-200 dark:text-gray-800 mb-6">Mevcut Değerlendirmeler</h2>
            
            {/* Average Rating */}
            <div className="text-center mb-6 p-4 bg-slate-700 dark:bg-gray-100 rounded-lg">
              <div className="text-3xl font-bold text-[#EFBB4C] mb-2">
                {averageRating > 0 ? averageRating : '-'}
              </div>
              <div className="flex justify-center mb-2">
                {[...Array(5)].map((_, index) => (
                  <FaStar
                    key={index}
                    className="text-xl"
                    color={index < Math.round(averageRating) ? "#EFBB4C" : "#ffffff"}
                    style={{ 
                      filter: document.documentElement.classList.contains('dark') ? 'invert(1)' : 'none',
                      color: index < Math.round(averageRating) ? "#EFBB4C" : (document.documentElement.classList.contains('dark') ? "#ffffff" : "#4a5568")
                    }}
                  />
                ))}
              </div>
              <p className="text-slate-300 dark:text-gray-600">
                {totalRatings} değerlendirme
              </p>
            </div>

            {/* Ratings List */}
            <div className="space-y-4 max-h-96 overflow-y-auto">
              {ratings.length > 0 ? (
                ratings.map((rating) => (
                  <div key={rating.id} className="bg-slate-700 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex">
                                               {[...Array(5)].map((_, index) => (
                         <FaStar
                           key={index}
                           className="text-sm"
                           color={index < rating.rating ? "#EFBB4C" : "#4a5568"}
                           style={{ 
                             filter: document.documentElement.classList.contains('dark') ? 'invert(1)' : 'none',
                             color: index < rating.rating ? "#EFBB4C" : (document.documentElement.classList.contains('dark') ? "#ffffff" : "#4a5568")
                           }}
                         />
                       ))}
                      </div>
                      <span className="text-sm text-slate-400">
                        {formatDate(rating.created_at)}
                      </span>
                    </div>
                    {rating.comment && (
                      <p className="text-slate-300 text-sm">{rating.comment}</p>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-center text-slate-400 dark:text-gray-500 py-8">
                  Henüz değerlendirme bulunmuyor.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiziDegerlendirin;
